import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=339e00be&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339e00be')) {
      api.createRecord('339e00be', component.options)
    } else {
      api.reload('339e00be', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=339e00be&", function () {
      api.rerender('339e00be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20YungjxTnnoC/JS/childrenage.vue"
export default component.exports